require("../../libs/backbone/backbone.ajaxq.adapter.ts");
var GenericView = require('views/generic.view.ts');
var Handlebars = require('handlebars');
var Template = require('text-loader!../templates/venue.template.htm');
require('dhtmlxMessage');
var Model = require('../models/venues.model.ts');
var MapView = require("views/map_location.view.ts");
var OrganizationsOptions = require("views/organizations_options.view.ts");
var VenuesOptions = require("views/venues_options.view.ts");
var i18n = require("l10n");

var TheView = GenericView.extend({
    el: "#container",
    tagName: 'div',
	template: Handlebars.compile(Template),
	superInitialize: GenericView.prototype.initialize,
	Model : null,
	id: null,
    editable: null,
    fields: null,
    userData: null,
    privilegeLevel: null,
    back: false,
	initialize: function (options) {
	    this.superInitialize();
	    var self = this;
	    this.id = options ? options.id : null;
	    this.userData = options.data;
	    this.privilegeLevel = this.privilegeLevelToNumber( this.userData.privilegeLevel);

        if(this.id)
        {
            this.editable = true;
            this.model = new Model({ id : this.id });
            this.model.fetch({
                success: function(response)
                {
                    self.render();
                    self.showMapBasic();
                },
                error: function(response, xhr, status)
                {
                     //console.info("error error");
                }
            });

        }
        else
        {
            this.editable = false;
            this.model = new Model();
            this.render();
            self.showMapBasic();
        }

        this.fields =
        {
            name: [this.isEmpty],
            address: [this.isEmpty, this.maxLengthNumber],
        };



	},
	superRender: GenericView.prototype.render,
	render: function () {
		this.superRender();
		var self = this;

		var data = $.extend(this.model.toJSON(), { editable: this.editable });
        this.$el.html(this.template(data));

        this.initTools(data);
	},
	events: {
	    //"click #location-button": "search",
        "click #submitBtn": "clickOnSubmit",
        "click #submitBack": "clickOnSubmitBack",
        "click #delete": "clickOnDelete",
        "click #cancel": "goBack",
        "click #reset": "clickOnReset",
        "change .to-validation input": "validateIt",
        "keyup .to-validation input": "validateIt",
        "keyup #description textarea": "validateDescription",
	},
	validateDescription: function()
	{
	   this.characterLeft("#description");
	},
	checkDescription: function() {
        var has_error = false;
        var description = $("#description").find("textarea").val().trim();

        if (description == "") {
            this.setError($("#description"), i18n.t("organization.empty_field"));
            has_error = true;
        }

        return has_error;

    },
	search: function()
	{
	    this.mapView.searchForAddress();
	},
	showMapBasic: function(e)
    {
        if(this.mapView == null)
            this.mapView = new MapView();

        this.mapView.renderMap();
    },
	clickOnSubmitBack: function(e)
    {
        this.back = true;
        this.mapView.saveMarkerClicked();
        this.clickOnSubmit(null);
    },
	clickOnSubmit: function(e)
    {
        var self = this;

        var has_error = this.validateFields(this.fields);
        //console.info("has_error: " + has_error);

        has_error = this.organizationsOptions.isTheDataWrong() || has_error;
        has_error = this.validateDescription() || has_error;
        var has_error3 = this.checkDescription();

        if( $("#latitude").find("input").val().trim() == 0 && $("#longitude").find("input").val().trim() == 0)
        {
            this.setError($("#address"), i18n.t("venue.select_pin"));
            has_error = true;
        }
        else
        {
          this.clearError($("#address"));
        }

        if(!has_error && !has_error3)
        {
            this.model.set("name", $("#name").find("input").val().trim());
            this.model.set("address", $("#address").find("input").val().trim());
            this.model.set("lat",$("#latitude").find("input").val().trim());
            this.model.set("lon", $("#longitude").find("input").val().trim());
            //this.model.set("phone", $("#phone").find("input").val().trim());
            //this.model.set("fax", $("#fax").find("input").val().trim());
            this.model.set("description", $("#description").find("textarea").val().trim());

            this.model.set("orgId", 1);
            if(!this.editable)
            {
                var orgId = this.organizationsOptions.getData();
                this.model.set("orgId", orgId);
            }

            this.showActionProgressBar();
            this.model.save(null, {
                success: function(response)
                {
                    self.hideActionProgressBar();
                    if(self.editable)
                    {
                        $.notify(i18n.t("venue.venue_updated"), { position:"top center", className: "success"});

                        if(self.back)
                            self.goBack();
                        self.back = false;
                    }
                    else
                    {
                        $.notify(i18n.t("venue.venue_added"), { position:"top center", className: "success" });
                        self.goBack();
                    }
                },
                error: function(response)
                {
                    self.hideActionProgressBar();
                    //console.info("error error");
                }
            });
        }
        else
        {
/*
            var target = "#submitBtn";
            if(this.id)
            {
                target = "#submit";
            }
*/
            $.notify(
                i18n.t("account.check_errors"),
                { position:"top center", className: "error" }
            );
        }
    },
    clickOnDelete: function(e)
    {
        var self = this;
        var removing_model = this.model;
        var venue_name = removing_model.get("name");

        dhtmlx.confirm({
            type: "confirm",
            text: i18n.t("venue.confirm_delete_venue") +" \"" + venue_name + "\" ?",
            ok: "Delete",
            cancel: "Cancel",
            callback: function (result) {
                //if yes -> delete the venue and return to venues page
                if (result) {
                    self.showActionProgressBar();
                    removing_model.destroy( {
                        success: function(response) {
                           self.hideActionProgressBar();

                           $.notify(i18n.t("venue.venue") + " \"" +  venue_name + "\" "+ i18n.t("organization.was_deleted"), { position:"top center", className: "success" });
                           self.goBack();
                        }
                    });
                }
            }
        });
    },
    clickOnReset: function(e)
    {
        $("#name").find("input").val("");
        $("#address").find("input").val("");
        $("#description").find("textarea").val("");
    },
    validateIt: function(event)
    {
        var element = $(event.currentTarget).parent();
        if(!element.hasClass("to-validation"))
            element = element.parent();

        var field = {};
        if(this.fields[element.prop("id")])
        {
            field[element.prop("id")] = this.fields[element.prop("id")]
            //console.info(field);
            this.validateFields( field );
        }
    },
    initTools: function(data)
    {
        var params =
        {
            userPrivilege: this.privilegeLevel,
            editable: this.editable
        };

        this.organizationsOptions = new OrganizationsOptions($.extend(params, { orgId: data.orgId } ));
        this.organizationsOptions.load();

    }
});

module.exports = TheView;